import type { ClientBasedAuth } from '@atlaskit/media-core';

import { ResourceRecorder } from './ResourceRecorder';
import { SuperbatchResourceRecorder } from './SuperbatchResourceRecorder';
import { ObjectRecorder } from './ObjectRecorder';
import { ThemeSSRManager } from './ThemeSSRManager';
import { SSRPrepareErrorsClient as errorClient } from './SSRPrepareErrorsClient';
import { SSRBannerManager } from './SSRBannerManager';
import { SSRContentStateManager } from './SSRContentStateManager';
import { SSREmojiTitleManager } from './SSREmojiTitleManager';
import { EditExperienceHandler } from './EditExperienceHandler';
import { SSRDisableHydrationRecorder } from './SSRDisableHydrationRecorder';
import { SSRPermissionsErrorHandler } from './SSRPermissionsErrorHandler';

export { SSRInlineScriptsInit } from './SSRInlineScriptsInit';

export { getSSRFeatureFlag, initFeatureFlags, getAllSSRFeatureFlags } from './SSRFeatureFlags';

export { SSRActionLoadingSpinner } from './SSRActionLoadingSpinner';
export { sanitizeDataForSSR, sanitizeDataForSSRWithoutQuotes } from './sanitizeDataForSSR';
export { setSSRRenderInputs, getSSRRenderInputs } from './ssrRenderInputs';

export { FullCycleRender, fullCycleRenderRegistry } from './FullCycleRender';

export {
	getSSRPartialSuccess,
	setSSRPartialSuccess,
	checkSSRPartialSuccess,
	SSR_PARTIAL_COMPONENT,
	SetSSRPartialSuccess,
	clearSSRPartialSuccess,
} from './ssrPartialSuccess';

export { useRenderServerPlaceholder } from './useRenderServerPlaceholder';
export { matchHydrationError, getHydrationErrorWithRoute } from './matchHydrationError';

export const ssrPrepareErrorsClient = new errorClient();
export const superbatchCSSRecorder = new SuperbatchResourceRecorder(false);
export const superbatchJSRecorder = new SuperbatchResourceRecorder(true);
export const mediaConfigRecorder = new ObjectRecorder<ClientBasedAuth>();
export const mediaConfigEnforceDSPRecorder = new ObjectRecorder<boolean>();
export const globalMacrosCSSRecorder = new ResourceRecorder();
export const globalMacrosJSRecorder = new ResourceRecorder();
export const themeSSRManager = new ThemeSSRManager();
export const ssrBannerManager = new SSRBannerManager();
export const ssrContentStateManager = new SSRContentStateManager();
export const ssrEmojiTitleManager = new SSREmojiTitleManager();
export const editExperienceHandler = new EditExperienceHandler();
export const ssrDisableHydrationRecorder = new SSRDisableHydrationRecorder();
export const ssrPermissionsErrorHandler = new SSRPermissionsErrorHandler();
